<template>
    <RouterView />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>
